import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { GruppeTierService } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

export interface GewichteFestlegenDialogInput {
    gruppeId: number;
    gruppeTiere: GruppeTier[];
}

@Component({
    selector: 'kiene-gewichte-festlegen-dialog',
    templateUrl: './gewichte-festlegen-dialog.component.html',
    styleUrls: ['./gewichte-festlegen-dialog.component.scss'],
})
export class GewichteFestlegenDialogComponent {
    einstallgewichtCtrl = new FormControl<number | null>(null, [Validators.min(0.000001)]);
    ausstallgewichtCtrl = new FormControl<number | null>(null, [Validators.min(0.000001)]);
    isLoading = false;
    submitAttempted = false;

    constructor(
        public dialogRef: MatDialogRef<GewichteFestlegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GewichteFestlegenDialogInput,
        private gruppeTierService: GruppeTierService,
        private messageService: MessageService,
    ) {}

    get anzahlTiere(): number {
        return this.data?.gruppeTiere?.length || 0;
    }

    private hasValue(value: number | null): boolean {
        return value !== null && value !== undefined;
    }

    get hasAnyGewichtValue(): boolean {
        return this.hasValue(this.einstallgewichtCtrl.value) || this.hasValue(this.ausstallgewichtCtrl.value);
    }

    get noValueErrorVisible(): boolean {
        return this.submitAttempted && !this.hasAnyGewichtValue;
    }

    close(): void {
        this.dialogRef.close();
    }

    save(): void {
        this.submitAttempted = true;
        this.einstallgewichtCtrl.markAsTouched();
        this.ausstallgewichtCtrl.markAsTouched();

        if (!this.hasAnyGewichtValue) {
            this.messageService.errorMessage('Bitte geben Sie mindestens ein Gewicht ein.', null);
            return;
        }

        if (this.einstallgewichtCtrl.invalid || this.ausstallgewichtCtrl.invalid) {
            this.messageService.errorMessage('Gewichtswerte muessen groesser als 0 sein.', null);
            return;
        }

        const gruppeTiere = this.data?.gruppeTiere ?? [];
        const gruppeId = Number(this.data?.gruppeId);

        this.isLoading = true;
        this.gruppeTierService
            .saveGewichteFestlegen(
                gruppeId,
                gruppeTiere,
                this.einstallgewichtCtrl.value,
                this.ausstallgewichtCtrl.value,
            )
            .subscribe({
            next: () => {
                this.messageService.infoMessage('Gewichte fuer selektierte Tiere wurden erfolgreich gespeichert.');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern der Gewichte.', err);
                this.isLoading = false;
            },
        });
    }
}
